<template>
  <div class="container">
    <div class="content">
      <div class="anchor2">
        <div @click="show=!show" class="clickArea">{{$t('m.OnThisPage')}}<i class="el-icon-arrow-down"></i> </div>
        <div v-if="show">
          <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">所有验证人</a></p>
          <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">某一高度验证人未提取挖矿收益</a></p>
          <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">委托人给验证人投票地址以及股份</a></p>
          <!-- <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4"></a></p>
          <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5"></a></p>
          <p @click="activeted(6)" class="s1"><a :class="{active:flag==6}" href="#box6"></a></p> -->
          <!-- <div class="subAnchor">
            <p @click="activeted(21)" class="s2"><a :class="{active:flag==21}" href="#box21">test</a></p>
            <p @click="activeted(22)" class="s2"><a :class="{active:flag==22}" href="#box22">test</a></p>
            <p @click="activeted(23)" class="s2"><a :class="{active:flag==23}" href="#box23">test</a></p>
            <p @click="activeted(24)" class="s2"><a :class="{active:flag==24}" href="#box24">test</a></p>
            <p @click="activeted(25)" class="s2"><a :class="{active:flag==25}" href="#box25">test</a></p>
            <p @click="activeted(26)" class="s2"><a :class="{active:flag==26}" href="#box26">test</a></p>
            <p @click="activeted(27)" class="s2"><a :class="{active:flag==27}" href="#box27">test</a></p>
          </div> -->
        </div>
      </div>
      <div class="p1">API</div>
      <div id="box1" class="p2">所有验证人</div>
      <div class="p3">请求方式 GET</div>
      <div class="p3">http://{ip}:26659/exchain/v1/staking/validators?status=all&height={number}</div>
      <div class="p3">请求参数</div>
      <div class="p3">number 区块高度，不加参数 height 参数表示最新高度</div>
      <div class="p3">返回</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0 5px 0">[</div>
          <div style="padding:5px 0 5px 35px">{</div>
          <div style="padding:5px 0 5px 55px">"operator_address": "fvaloper1qg3pkkuw7zuz8h39h36ttt4xq6nhx3a043svlz",</div>
          <div style="padding:5px 0 5px 55px">"consensus_pubkey": "fvalconspub1zcjduepqn7wscltrcjfv82z97fczgfyzjzf5chdtd2564al2669my87vz9wsgxykg4",</div>
          <div style="padding:5px 0 5px 55px">"jailed": false,</div>
          <div style="padding:5px 0 5px 55px">"status": 2,</div>
          <div style="padding:5px 0 5px 55px">"tokens": "0",</div>
          <div style="padding:5px 0 5px 55px">"delegator_shares": "14691663.875493595097213985",</div>
          <div style="padding:5px 0 5px 55px">"description": {</div>
          <div style="padding:5px 0 5px 75px">"moniker": "node14",</div>
          <div style="padding:5px 0 5px 75px">"identity": "22logo|||http://mywebsite/pic/logo.jpg",</div>
          <div style="padding:5px 0 5px 75px">"website": "http://mywebsite"</div>
          <div style="padding:5px 0 5px 75px">"details": "90"</div>
          <div style="padding:5px 0 5px 55px">},</div>
          <div style="padding:5px 0 5px 55px">"unbonding_height": "494960",</div>
          <div style="padding:5px 0 5px 55px">"unbonding_time": "2022-04-13T23:28:24.973922257Z",</div>
          <div style="padding:5px 0 5px 55px">"commission": {</div>
          <div style="padding:5px 0 5px 75px">"commission_rates": {</div>
          <div style="padding:5px 0 5px 95px">"rate": "1.000000000000000000",</div>
          <div style="padding:5px 0 5px 95px">"max_rate": "1.000000000000000000"</div>
          <div style="padding:5px 0 5px 95px">"max_change_rate": "0.000000000000000000"</div>
          <div style="padding:5px 0 5px 75px">},</div>
          <div style="padding:5px 0 5px 75px">"update_time": "1970-01-01T00:00:00Z"</div>
          <div style="padding:5px 0 5px 55px">},</div>
          <div style="padding:5px 0 5px 55px">"min_self_delegation": "30000.000000000000000000"</div>
          <div style="padding:5px 0 5px 35px">}</div>
          <div style="padding:5px 0 5px 0">]</div>
        </div>
      </div>
      <div class="p3">返回参数</div>
      <div class="p3">
        <ul style="padding-left:30px;word-break:break-all">
          <li>验证人地址 operator_address</li>
          <li>验证人股份 delegator_shares</li>
          <li>验证人是否监禁 jailed</li>
          <li>验证人分配比例 details</li>
          <li>验证人质押币量 min_self_delegation</li>
          <li>验证人状态 status ，0 Unbonded，1 Unbonding，2 Bonded</li>
        </ul>
      </div>
      <div id="box2" class="p2">某一高度验证人未提取挖矿收益</div>
      <div class="p3">请求方式 GET</div>
      <div class="p3">http://{ip}:26659/exchain/v1/distribution/validators/{operator_addr}/validator_commission?height={number}</div>
      <div class="p3">请求参数</div>
      <div class="p3">operator_addr 验证人地址</div>
      <div class="p3">number 区块高度，不加参数 height 参数表示最新高度</div>
      <div class="p3">返回</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0 5px 0">[</div>
          <div style="padding:5px 0 5px 35px">{</div>
          <div style="padding:5px 0 5px 55px">"denom": "fax",</div>
          <div style="padding:5px 0 5px 55px">"amount": "3977.969379928995934395"</div>
          <div style="padding:5px 0 5px 35px">}</div>
          <div style="padding:5px 0 5px 0">]</div>
        </div>
      </div>
      <div class="p3">返回参数</div>
      <div class="p3">验证人未提取挖矿收益 amount</div>
      <div id="box3" class="p2">委托人给验证人投票地址以及股份</div>
      <div class="p3">请求方式 GET</div>
      <div class="p3">http://{ip}:26659/exchain/v1/staking/validators/{operator_addr}/shares?height=669620</div>
      <div class="p3">请求参数</div>
      <div class="p3">operator_addr 验证人地址</div>
      <div class="p3">number 区块高度，不加参数 height 参数表示最新高度</div>
      <div class="p3">返回</div>
      <div class="p3">
        <div style="padding:15px 10px;word-break:break-all;background:#F5F6FA;font-size:14px">
          <div style="padding:5px 0 5px 0">[</div>
          <div style="padding:5px 0 5px 35px">{</div>
          <div style="padding:5px 0 5px 55px">"delegator_address": "f1pj3uy4r9nspydpshqfvxv78v8c0ptqhedwsg3y",</div>
          <div style="padding:5px 0 5px 55px">"shares": "51914003.093616943806409840"</div>
          <div style="padding:5px 0 5px 35px">},</div>
          
          <div style="padding:5px 0 5px 35px">{</div>
          <div style="padding:5px 0 5px 55px">"delegator_address": "f1lfypqp04zlg07xhczv0p07lq992frydthervwq",</div>
          <div style="padding:5px 0 5px 55px">"shares": "39903169.274274982511997224"</div>
          <div style="padding:5px 0 5px 35px">}</div>
          <div style="padding:5px 0 5px 0">]</div>
        </div>
      </div>
      <div class="p3">返回参数</div>
      <div class="p3">委托人地址 delegator_address</div>
      <div class="p3">委托人股份 shares</div>
      
    </div>
    
    <div class="wrapper">
    <div class="anchor1">
      <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">所有验证人</a></p>
      <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">某一高度验证人未提取挖矿收益</a></p>
      <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">委托人给验证人投票地址以及股份</a></p>
      <!-- <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4"></a></p>
      <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5"></a></p>
      <p @click="activeted(6)" class="s1"><a :class="{active:flag==6}" href="#box6"></a></p> -->
      <!-- <div class="subAnchor">
        <p @click="activeted(21)" class="s2"><a :class="{active:flag==21}" href="#box21">test</a></p>
        <p @click="activeted(22)" class="s2"><a :class="{active:flag==22}" href="#box22">test</a></p>
        <p @click="activeted(23)" class="s2"><a :class="{active:flag==23}" href="#box23">test</a></p>
        <p @click="activeted(24)" class="s2"><a :class="{active:flag==24}" href="#box24">test</a></p>
        <p @click="activeted(25)" class="s2"><a :class="{active:flag==25}" href="#box25">test</a></p>
        <p @click="activeted(26)" class="s2"><a :class="{active:flag==26}" href="#box26">test</a></p>
        <p @click="activeted(27)" class="s2"><a :class="{active:flag==27}" href="#box27">test</a></p>
      </div> -->
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'API',
  data() {
    return {
      flag: 1,
      show: false
    }
  },
  methods: {
    activeted(i) {
      console.log('i',i);
      this.flag = i
    }
  },
  mounted() {
    window.scroll(0, 0)
  }
}
</script>


<style lang="sass" scoped>
span
  padding: 2px 5px
  color: red
  border: 1px solid #ccc
  font-size: 12px
@media screen and (min-width:980px)
  .container
    display: flex
    .content
      width: 78%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
      .p3
        line-height: 25px
        padding-bottom: 15px
        word-break: break-all
    .anchor2
      display: none
    .wrapper
      width: 22%
    .anchor1
      position: sticky
      top: 0px
      right: 0px
      padding: 0 15px
      padding-right: 0
      // width: 18%
      color: #525860
      font-size: 14px
      border-left: 1px solid #DADDE1
      .active  
        color: #7549A9
      .subAnchor
        padding: 0 15px
      a
        color: #525860
      a:hover
        color: #7549A9
        font-size: 15px
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
@media screen and (max-width:980px)
  .container
    display: flex
    .content
      overflow: auto
      // width: 75%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
        padding-top: 60px
        margin-top: -60px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
        padding-top: 60px
        margin-top: -60px
      .p3
        line-height: 25px
        padding-bottom: 15px
        word-break: break-all
    .anchor1
      display: none
    .anchor2
      background: #F2F2F2
      border-radius: 5px
      color: #000
      padding: 10px 15px
      padding-right: 0
      // width: 25%
      font-size: 16px
      .clickArea
        padding-right: 15px
        color: #000
        display: flex
        justify-content: space-between
      .active  
        color: #7549A9
      .subAnchor
        padding-left: 15px
      a
        color: #525860
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
</style>